import { render, staticRenderFns } from "./SelectItemAgropecuario.vue?vue&type=template&id=2c98bbb6&scoped=true"
import script from "./SelectItemAgropecuario.vue?vue&type=script&lang=js"
export * from "./SelectItemAgropecuario.vue?vue&type=script&lang=js"
import style0 from "./SelectItemAgropecuario.vue?vue&type=style&index=0&id=2c98bbb6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c98bbb6",
  null
  
)

export default component.exports